import { render, staticRenderFns } from "./ResumoObito.vue?vue&type=template&id=40f8619d&scoped=true&"
import script from "./ResumoObito.vue?vue&type=script&lang=js&"
export * from "./ResumoObito.vue?vue&type=script&lang=js&"
import style0 from "./ResumoObito.vue?vue&type=style&index=0&id=40f8619d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8619d",
  null
  
)

export default component.exports